<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('help.questions-title')"
    >
      <template slot="title">
        <div class="d-flex">
          <b-button
            variant="dark"
            size="md"
            @click="showModal=true, selectedQuestion =null"
          >
            <span class="align-middle"> {{ $t('help.add-question') }}</span>
          </b-button>
        </div>
      </template>
      <b-row>
        <b-col md="12">
          <ok-table
            ref="datatable"
            :config="tableConfig"
            @edit="handleEdit"
            @delete="handleDelete"
          />
        </b-col>
      </b-row>
    </empty-card>
    <ok-confirm-modal
      v-if="deleteQuestion"
      :show-cancel="true"
      @confirm="removeQuestion"
      @cancel="deleteQuestion=null"
    />
    <process-question
      v-model="showModal"
      :question="selectedQuestion"
      @processed="refreshTable"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import cloneDeep from 'lodash/cloneDeep'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import { API_URL } from '@/constants/config'
import OkConfirmModal from '@/@bya3/components/modals/OkConfirmModal'
import HelpAPI from '@/api/admin/help-api'
import QuestionsTableConfig from './config/questions-table-config'
import ProcessQuestion from './components/ProcessQuestion'

export default {
  components: {
    ProcessQuestion,
    OkConfirmModal,
    EmptyCard,
    BRow,
    BCol,
    BButton,
    OkTable: () => import(/* webpackChunkName: "ok-table" */ '@/@bya3/components/tables/ok-table/OkTable'),
  },
  data() {
    return {
      showModal: false,
      selectedQuestion: null,
      deleteQuestion: null,
    }
  },
  computed: {
    tableConfig() {
      const conf = cloneDeep(QuestionsTableConfig)
      const { id } = this.$route.params
      conf.url = `${API_URL}/admin/help/section/questions/${id}`
      return conf
    },
  },
  methods: {
    refreshTable() {
      this.selectedQuestion = null
      this.showModal = false
      this.$refs.datatable.loadItems()
    },
    handleEdit(props) {
      this.showModal = true
      this.selectedQuestion = props.row
    },
    handleDelete(props) {
      this.deleteQuestion = props.row.id
    },
    removeQuestion() {
      HelpAPI.delete(this.deleteQuestion, 'question')
        .then(response => {
          if (!response.error) {
            this.$notifySuccess(response.message)
            this.refreshTable()
            this.deleteQuestion = null
          } else this.$notifyError(response.message)
        })
        .catch(error => this.$notifyError(error))
    },
  },
}
</script>
